export default __webpack_public_path__ + "static/media/Hume.cc5bac91.jpeg";